var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-check-box"},[_c('label',{staticClass:"checkbox-wrapper"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('input',_vm._b({attrs:{"type":"checkbox","id":`base-check-box__input-${_vm.id}`},domProps:{"checked":_vm.isChecked}},'input',_vm.$attrs,false)),_c('span',{staticClass:"base-check-box__check-mark",class:[
                { 'base-check-box__check-mark--checked': _vm.isChecked },
                `base-check-box__check-mark--${_vm.size}`
            ]},[(_vm.isChecked)?_c('img',{attrs:{"src":require("../../assets/icons/icon-check-v2.svg")}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }